import { Action, createReducer, on } from '@ngrx/store';
import { configFailed, configLoaded, configLoadedFromStorage } from '../actions/config.actions';
import { ConfigState, initialConfigState } from '../config.state';
import { LoadStatus } from '../../load-status';

const setEntriesReducer = (
    state: Readonly<ConfigState>,
    { configValues }: { configValues: Record<string, string> },
): Readonly<ConfigState> => ({
    ...state,
    configValues,
    status: LoadStatus.Loaded,
});

const createConfigReducer = createReducer(
    initialConfigState,
    // Both the backend load and the storage rehydrate populate the slice identically; they are
    // distinct actions only so the persist effect fires for the backend load, not the rehydrate.
    on(configLoaded, configLoadedFromStorage, setEntriesReducer),
    on(configFailed, (state) => ({ ...state, status: LoadStatus.Error })),
);

export function configReducer(state: Readonly<ConfigState> | undefined, action: Action): Readonly<ConfigState> {
    return createConfigReducer(state, action);
}
